export const setInlineClasses = () => {
  const tabsList = document.querySelectorAll('leaf-tab');
  if (tabsList.length >= 1) {
    tabsList.forEach((tab) => {
      tab.closest('.iw_placeholder')?.classList.add('leaf-u-overflow-hidden');
    });
  }
};
